<template>
  <div id="app" class="w-100">
    <transition name="fade">
      <div
        class="background"
        id="background"
        v-if="backgroundImageUrl"
        :style="{
          backgroundImage: `url(
        ${backgroundImageUrl}&w=1500&dpr=2
      )`
        }"
      ></div>
    </transition>
    <div class="content bg-trans-20-dark-blue w-100">
      <transition name="fade">
        <router-view class="w-100" v-show="!focusImage"
      /></transition>
      <div
        v-if="user && background.links && $route.path !== '/'"
        class="image-credit position-fixed text-right d-none d-md-block"
      >
        By
        <a
          :href="
            `${background.links.html}?utm_source=shinkanote&utm_medium=referral`
          "
          target="_blank"
        >
          {{ background.user.name }}</a
        >
        on
        <a
          :href="
            `https://unsplash.com/?utm_source=shinkanote&utm_medium=referral`
          "
          target="_blank"
          >Unsplash</a
        >
        <a
          href="#"
          class="add-to-favourites"
          @click="addToFavourites(background)"
          ><i class="fa fa-heart ml-2"></i
        ></a>
        <a
          href="#"
          @mouseenter="focusImage = true"
          @mouseleave="focusImage = false"
          ><i class="fa fa-image ml-2"></i
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      focusImage: false
    };
  },
  computed: {
    ...mapGetters({
      backgroundImageUrl: "getBackgroundImageUrl",
      background: "getBackgroundImage",
      error: "getError",
      user: "getUser"
    })
  },
  methods: {
    ...mapActions({
      fetchBackgroundImage: "fetchBackgroundImage",
      fetchUser: "fetchUser",
      addToFavourites: "addToFavourites"
    })
  },
  async created() {
    this.fetchBackgroundImage();
    await this.fetchUser();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";

body {
  background: #999;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}

.background {
  height: 100vh;
  position: fixed;
  top: 0;
  width: 100%;
  background: no-repeat center center fixed;
  background-size: cover;
  z-index: -1;
}

.content {
  min-height: 100vh;
  padding-bottom: 1px;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
  }
}

.image-credit {
  bottom: 1rem;
  right: 1rem;
  color: #fff;
  a {
    color: #fff;
    &:hover {
      opacity: 0.8;
      color: inherit;
    }
  }
}
</style>
